__turbopack_context__.v({
  "Cont": "HomeHero-module-sass-module__Qha1rG__Cont",
  "Copy": "HomeHero-module-sass-module__Qha1rG__Copy",
  "Down": "HomeHero-module-sass-module__Qha1rG__Down",
  "HomeHero": "HomeHero-module-sass-module__Qha1rG__HomeHero",
  "Image": "HomeHero-module-sass-module__Qha1rG__Image",
  "NoProject": "HomeHero-module-sass-module__Qha1rG__NoProject",
  "Project": "HomeHero-module-sass-module__Qha1rG__Project",
  "ProjectCategory": "HomeHero-module-sass-module__Qha1rG__ProjectCategory",
  "ProjectImage": "HomeHero-module-sass-module__Qha1rG__ProjectImage",
  "ProjectInner": "HomeHero-module-sass-module__Qha1rG__ProjectInner",
  "ProjectMain": "HomeHero-module-sass-module__Qha1rG__ProjectMain",
  "Title": "HomeHero-module-sass-module__Qha1rG__Title",
  "bounce": "HomeHero-module-sass-module__Qha1rG__bounce",
});
